import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FunctionsService } from '../__common/functions.service';
import { ResolverService } from '../__common/resolver.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
  constructor(private router: Router,private resolver: ResolverService,private commonFunctions: FunctionsService) {}

  canActivate(): boolean {
    if(this.resolver.getDependencyRecords('getThisClientApps').length<=0){
      this.router.navigate(['/home']); // Redirect to home
      return false; // Prevents further navigation
    }else{
      return true;
    }
    
  }

  isLoggedOut(){
    if(this.commonFunctions.getSelectedClientId() ){
      this.router.navigate(['/home']);
    }else{
      return false;
    }
  }
}
